module.exports = __webpack_public_path__ + "static/media/pic1.03a62654.jpg";